define('views/modules/calendar/calendar-item-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // Events
    'services/events/calendar-events',
    // Views
    'views/parts/panel/base-panel',
], function(
    // Libs
    _, Backbone, Mustache, U,
    //Events
    CalendarEvents,
    // views
    VBasePanel
) {

    var VCalendarItemPanel = VBasePanel.extend({
        header: {
            title: "calendar:Calendar Item",
            subtitle: "calendar:Manage an item",
        },

        constructor: function(options) {
            VCalendarItemPanel.__super__.constructor.apply(this, arguments);

            this.listenTo(CalendarEvents, {
                'item:destroy': this.onItemDestroy
            });
        },

        getContentViewOptions: function(options) {
            return _.extend({
                model: this.model,
            }, this.options, options);
        },

        onContentViewCreate: function(view, options) {
            this.listenTo(view, {
                "form:success": this.onSuccess,
                "save:button:form:success": this.onSaveButtonFormSuccess,
                "favorite:applied": this.onFavoriteApplied,
                "favorite:success": this.onFavoriteSuccess,
                "drawer:view": this.onSetDrawerView
            });
        },

        showFeedback: function() {
            var view = this.view,
                feedback = this.getView('feedback');
            if (view.details) {
                feedback.resetModel(view.details.model.attributes, { silent: true });
            }
            this.showContent('feedback');
        },

        showDetails: function() {
            var view = this.view,
                details = this.getView('details');
            if (view.feedback) {
                details.resetModel(view.feedback.model.attributes, { silent: true });
            }
            this.showContent('details');
        },

        ////////////
        // events //
        ////////////

        onSuccess: function() {
            CalendarEvents.itemUpdate(this.model.clone());
        },

        onClosePanel: function() {
            var view = this.view,
                feedback = view.feedback;
            view.details.setPristine();
            if (feedback) feedback.setPristine();
        },

        onSaveButtonFormSuccess: function() {
            this.close();
        },

        onFavoriteApplied: function() {
            this.showDetails();
        },

        onFavoriteSuccess: function() {
            this.showFavorite();
        },

        onSetDrawerView: function(view, open) {
            this.trigger("drawer:view", view, open);
        },

        onItemDestroy: function(id) {
            var model = this.model;
            if (model.is(id) && model.isReferencedInUrl()) this.close();
        },

    });

    return VCalendarItemPanel;
});

